// Auth provider contract for the API client.
// See react-rewrite-plan.md sections 8.2 and 11.3 api-client.
//
// The client depends on this interface instead of importing from
// `@/shared/auth` directly. In Phase A the auth slice is on a separate task
// branch so cross-branch imports would not resolve. In Phase B integration
// the app wires shared/auth.getToken into a small adapter that satisfies
// AuthTokenProvider and passes it to createApiClient.

export interface AuthTokenProvider {
  getToken(): string | null;
}

// Default provider used when callers do not supply one. Returns null so no
// Authorization header is added.
export const nullAuthProvider: AuthTokenProvider = {
  getToken: () => null,
};
